import { ReactNode } from 'react';

import { Link, ListItem, ListItemIcon, ListItemText, Typography } from '@mui/material';
import { useRouter } from 'next/router';

import useStyles from './styles';

export default function SidebarLink({ link, text, icon }: { icon: ReactNode; text: string; link: string }) {
  const classes = useStyles();
  const router = useRouter();

  return (
    <Link className={classes.link} href={link}>
      <ListItem className={`${classes.item} ${router.pathname === link && classes.itemSelected}`}>
        <ListItemIcon className={classes.itemIcon}>{icon}</ListItemIcon>
        <ListItemText primary={<Typography style={{ color: 'currentColor' }}>{text}</Typography>} />
      </ListItem>
    </Link>
  );
}
